import React from "react";
import PromineoIconSvg from "static/images/promineo-icon.svg";
import { getConfiguration } from "shared/utility/ConfigUtility";

export default function Logo(): React.ReactElement {
  const promineoSiteUrl = getConfiguration("promineoSiteUrl");
  return (
    <div className="inline-block">
      <span className="text-4xl font-extrabold font-avenir">timePhasing</span>
      <div className="flex">
        <span className="mr-1">part of </span>
        <div className="mt-1">
          <a href={promineoSiteUrl}>
            <img src={PromineoIconSvg} alt="promineo" />
          </a>
        </div>
      </div>
    </div>
  );
}
